import React from "react"
import { useMap } from "@vis.gl/react-google-maps"
import { useGoogleMapsEffect } from "../lib/hooks/useGoogleMapsEffect"
import { GeoJsonLayerStyle } from "../lib/helpers/googleMap"

interface GeoJsonProps {
  mapId: string
  geoJson: object | null
  style?: GeoJsonLayerStyle
  onClick?: (event: any) => void
}

const GeoJson: React.FC<GeoJsonProps> = ({ mapId, geoJson, style, onClick }) => {
  const map = useMap(mapId)
  const dataRef = React.useRef<google.maps.Data | null>()

  useGoogleMapsEffect(
    mapId,
    () => {
      // clear previous
      if (dataRef.current) {
        dataRef.current.forEach((gMapFeature) => map?.data.remove(gMapFeature))
        dataRef.current.setMap(null)
        dataRef.current = null
      }

      if (!geoJson) return

      // create layer, fill with data and add to the map
      const dataLayer = new google.maps.Data()
      dataLayer.addGeoJson(geoJson)
      dataLayer.setMap(map)

      // add style if needed
      if (style) {
        dataLayer.setStyle(style)
      }

      // add click listener if needed
      if (onClick && typeof onClick === "function") {
        dataLayer?.addListener("click", onClick)
      }

      dataRef.current = dataLayer
    },
    [dataRef, style, geoJson],
  )

  // cleanup effect
  React.useEffect(() => {
    return () => {
      if (dataRef.current) {
        dataRef.current.forEach((gMapFeature) => map?.data.remove(gMapFeature))
        dataRef.current.setMap(null)
        dataRef.current = null
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataRef])

  return null
}

export default GeoJson
